<template>
  <div class="swiper-container subscribeCampaign" :id="swiperId">
    <div class="swiper-wrapper">
    <slot>
    </slot>
    </div>
  </div>
</template>

<script>
import SwiperJsMixin from './SwiperJsMixin'
// import 'swiper/dist/css/swiper.css'

export default {
  name: 'SwiperJs',
  mixins: [
    SwiperJsMixin
  ],
  mounted () {
    // console.log('SwiperJS mounted', this.activeStep)
  },
  methods: {
    clear () {
      this.activeStep = 0
      this.swipeTo(0)
    }
  }
}
</script>